import { get } from 'lodash';
import { connect } from 'react-redux';

import PdpProductSelector from 'components/PdpProductSelector';
import * as actions from 'state/actions';
import {
  getIsLoadingMasterProduct,
  getCurrentProduct,
  getProductsGroupedByEdition,
  getProductsGroupedByPrice,
  isSalePdp,
} from 'state/selectors/pdp';

const mapStateToProps = (state, ownProps) => {
  const isLoading = getIsLoadingMasterProduct(state);

  const currentProduct = getCurrentProduct(state);

  const isSalePdpPage = isSalePdp();

  const currentProductHandle = get(currentProduct, 'handle');
  const currentProductName = get(currentProduct, 'colorName');

  let groupedProducts;
  let currentProductLabel;

  if (isSalePdpPage) {
    groupedProducts = getProductsGroupedByPrice(state);
    currentProductLabel = get(currentProduct, 'formattedPrice');
  } else {
    groupedProducts = getProductsGroupedByEdition(state);
    currentProductLabel = get(currentProduct, 'edition');
  }

  return {
    isLoading,
    currentProductLabel,
    currentProductName,
    currentProductHandle,
    groupedProducts,
    isSalePdp: isSalePdpPage,
    ...ownProps,
  };
};

const mapDispatchToProps = dispatch => ({
  onSelect: handle => dispatch(actions.setCurrentProduct(handle)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PdpProductSelector);
